export function SectionHeading({ label, title, subtitle, center = true, className = "" }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl ${className}`}>
      {label && <div className="label-lux mb-3">{label}</div>}
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">{title}</h2>
      {subtitle && <p className="mt-4 text-slate-400 leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <div className={`fade-up ${className}`} style={{ animationDelay: `${delay}ms` }}>{children}</div>
  );
}
